module.exports = __webpack_public_path__ + "img/icons8-info.3ed47dc2.gif";